import { render } from "./detail.vue?vue&type=template&id=204a65c6"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"
script.render = render

export default script